<template>
  <div class="caifu_ts" id="tsdj">
    <topNav typeName vuePage="#tsdj" title="活跃等级说明" back="1"></topNav>
    <div class="ts_top">
      <p>什么是活跃等级?</p>
      <p>活跃等级是活跃度、消费能力的综合体现。</p>
    </div>

    <div class="ts_top">
      <p>活跃等级的分值是如何计算的?</p>
      <p>分值=活跃值+消费值</p>
    </div>

    <div class="ts_top">
      <p>活跃等级有上限吗?</p>
      <p>活跃等级不设上限，随着活跃值、消费值的升高，活跃等级将不断提升。</p>
    </div>
  </div>
</template>





<script>
import topNav from "../index/top_nav";

export default {
  components:{topNav},
  data() {
    return {};
  },
  methods: {},
  mounted () {
    this.$tool.setTitle("活跃等级说明")
  }
};
</script>





<style scoped>
.caifu_ts {
  width: 100%;
}
.ts_top {
  width: 100%;
  padding: 0 15px;
  margin: 0 auto;
  background-color: #fff;
}
.ts_top p:nth-child(1) {
  color: #333;
  padding: 18px 0;
  font-size: 1rem;
}
.ts_top p:nth-child(2) {
  color: #666;
  font-size: 0.95rem;
  padding: 20px 0;
  padding-top: 0;
  line-height: 1.5;
}
</style>